<template>
  <div class="content mb-5">
    <h2>{{ $t("Links") }}</h2>
    <b-row class="mb-6">
      <b-col sm="12" md="6" lg="6">
        <b-form-group
          v-if="!loading"
          class="mb-3"
          label-for="name"
          :label="this.$t('Support Desk URL')"
          :state="$validateState($v.form.supportDesk)"
        >
          <b-form-input
            id="supportDesk"
            data-test-id="support-support-desk-url"
            @blur="setValidationInput('supportDesk', $event.target.value)"
            :state="$validateState($v.form.supportDesk)"
            :placeholder="$t('Enter URL')"
          />

          <template #invalid-feedback>
            <p v-if="!$v.form.supportDesk.required">
              {{ $t("This is a required field.") }}
            </p>
            <p
              v-if="
                $v.form.supportDesk.required && !$v.form.supportDesk.minLength
              "
            >
              {{ $t("Must contain at least 5 characters.") }}
            </p>
            <p
              v-if="
                $v.form.supportDesk.required && !$v.form.supportDesk.maxLength
              "
            >
              {{ $t("Must contain at most 200 characters.") }}
            </p>
          </template>
        </b-form-group>
        <b-skeleton
          v-if="loading"
          animation="wave"
          height="32px"
          width="100%"
        ></b-skeleton>
      </b-col>
      <b-col sm="12" md="6" lg="6">
        <b-form-group
          v-if="!loading"
          class="mb-3"
          label-for="name"
          :label="this.$t('Contact')"
          :state="$validateState($v.form.contact)"
        >
          <b-form-input
            id="contact"
            data-test-id="support-email"
            @blur="setValidationInput('contact', $event.target.value)"
            :state="$validateState($v.form.contact)"
            :placeholder="$t('Enter email address')"
          />

          <template #invalid-feedback>
            <p v-if="!$v.form.contact.required">
              {{ $t("This is a required field.") }}
            </p>
            <p v-if="$v.form.contact.required && !$v.form.contact.minLength">
              {{ $t("Must contain at least 5 characters.") }}
            </p>
            <p v-if="!$v.form.contact.maxLength">
              {{ $t("Must contain at most 200 characters.") }}
            </p>
          </template>
        </b-form-group>
        <b-skeleton
          v-if="loading"
          animation="wave"
          height="32px"
          width="100%"
        ></b-skeleton>
      </b-col>
    </b-row>
    <t-save-button
      data-test-id="support-save"
      :fetching="fetching"
      @submit="onSubmit"
      :form-model="$v.form"
    />
  </div>
</template>

<route>
{
  "name": "Customer Support",
  "meta": {
    "authorize" : [1, 3, 4]
  }
}
</route>

<script>
import { mapActions, mapGetters } from "vuex";
import { required, minLength, maxLength } from "vuelidate/lib/validators";

export default {
  layout: "customer",
  data() {
    return {
      fetching: false,
      loading: true,
      form: {
        supportDesk: null,
        contact: null,
      },
    };
  },
  methods: {
    ...mapActions("pageMeta", ["setPageTitle", "setPageSubtitle"]),
    ...mapActions("toast", ["displayToast"]),
    setValidationInput(object, value) {
      this.form[`${object}`] = value;
      this.$v.form[`${object}`].$touch();
    },
    onSubmit() {
      this.fetching = true;
      try {
        this.displayToast({
          title: this.$t("Error"),
          message: "Missing endpoint.",
          duration: 2000,
          variant: "warning",
        });
      } finally {
        this.fetching = false;
      }
    },
  },
  computed: {
    ...mapGetters("authentication", ["selectedUser"]),
  },
  validations: {
    form: {
      supportDesk: {
        required,
        minLength: minLength(3),
        maxLength: maxLength(200),
      },
      contact: {
        required,
        minLength: minLength(3),
        maxLength: maxLength(200),
      },
    },
  },
  watch: {
    customerPolicies() {
      this.policyOptions = [
        {
          value: null,
          text: this.$t("Select Policy"),
          disabled: true,
        },
        {
          value: "default",
          text: this.$t("Default Policy"),
        },
        ...this.customerPolicies.map((p) => {
          return { value: p.id, text: p.name };
        }),
      ];
    },
  },
  async created() {
    try {
      this.setPageTitle(this.$t("Support"));
    } finally {
      this.loading = false;
    }
  },
  mounted() {
    this.setPageSubtitle([
      this.$t(
        "Customize the links to your support services offered to your customers in their profile menu."
      ),
    ]);
  },
};
</script>
